<template>
    <div>
        <div class="resp" v-if="isObject(data)" v-for="(value, key) in data" :key="key">
            <div class="resp__key">{{key}}</div>

            <status-response
                v-if="Array.isArray(value) && value.length"
                :data="value"
            />

            <status-response
                v-else-if="isObject(value)"
                :data="value"
            />

            <div v-else>
                <div class="resp__value">{{value}}</div>
            </div>
        </div>

        <status-response
            v-if="Array.isArray(data)"
            v-for="(item, index) of data"
            :key="index"
            :data="item"
        />
    </div>
</template>

<script>
import {object} from '@/utils/mixins'
export default {
    name: 'status-response',

    mixins: [object],

    props: {
        data: {
            type: Object|Array,
            required: true
        }
    },
}
</script>

<style lang="scss">
.resp {
    margin: 10px;
    background-color: rgba(var(--vs-success), .2);
    padding: 10px;
    border-radius: 10px;

    &__key {
        text-transform: uppercase;
    }
}
</style>
